export const urls = Object.freeze({
    GET_GLOBAL_CONFIGS: '/api/get_global_conf/',
    SET_GLOBAL_CONFIGS: '/api/set_global_conf/',
    SAVE_CAP_REPORT: '/api/save_cap_report/',
    GET_GROUPS_FOR_SHARING: '/api/share/get_groups/',
    SHARE_SLIDE_TO_GROUPS: '/api/share/assign_slide_to_groups/',
    ASSIGN_CASES_TO_GROUPS: '/api/assign_cases_to_groups/',
    GET_LIST_OF_ACCESS_FOR_SHARING: '/api/share/get_slides_access_list/',
    GET_LIST_OF_ACCESS_FOR_SHARING_CASE: '/api/share/get_cases_access_list/',
    REVOKE_SHARE_ACCESS: '/api/share/revoke_access/',
    REVOKE_ACCESS_TO_CASE: '/api/remove_user_from_case/',
    GENERATE_ANONYMOUS_SHARE_LINK: '/api/share/generate_anonymous_link/',
    GET_ALL_ANONYMOUS_SHARE_LINKS: '/api/share/get_all_anonymous_links/',
    DELETE_SHARE_TOKEN: '/api/share/delete_share_token/',
    GET_LIST_OF_SHARED_SLIDES_FROM_TOKEN: '/api/share/get_list_of_shared_slides_from_token/',
    ADD_SLIDES_TO_CASE: '/api/add_slides_to_case/',
    GET_INACCESSIBLE_PERMISSIONS_FOR_ORGANISATION: '/api/organisation/get_inaccessible_permissions/',
    SET_INACCESSIBLE_PERMISSIONS_FOR_ORGANISATION: '/api/organisation/set_inaccessible_permissions/',
    DELETE_ORGANISATION: '/api/organisation/delete_organisation/',
    GET_ALL_ACCESS_PERMISSION_CATEGORIES: '/api/get_all_access_permission_categories/',
    GET_ALL_ACCESS_POLICIES: '/api/access_policy/',
    GET_ALL_ACCESS_PERMISSIONS: '/api/get_all_access_permissions/',
    GET_ACCESS_POLICY_PERMISSIONS_AND_MEMBERS: '/api/get_access_policy_permissions_and_members/',
    CREATE_ACCESS_POLICY: '/api/create_access_policy/',
    UPDATE_PERMISSIONS_IN_ACCESS_POLICY: '/api/update_permissions_in_access_policy/',
    UPDATE_MEMBERS_IN_ACCESS_POLICY: '/api/update_members_in_access_policy/',
    GET_USER_ACCESS_PERMISSIONS_AND_POLICY: '/api/get_user_access_permissions_and_policy/',
    DELETE_ACCESS_POLICY: '/api/delete_access_policy/',
    GET_DEFAULT_POLICIES: '/api/get_default_policies/',
    UPDATE_ACCESS_PERMISSIONS_FOR_USER: '/api/update_access_permissions_for_user/',
    GET_READ_STATUSES_FOR_SLIDE: '/api/all_slide_read_statuses/',
    GET_DICOM_TILE_DATA: '/api/dicom/dicom_tile_data/',
    GET_DICOM_BARCODE: '/api/dicom/dicom_barcode/',
    GET_DICOM_PREVIEW: '/api/dicom/dicom_preview/',
    GET_SEARCH_TAG_RESULTS:  '/api/search/tag/',
    GET_SEARCH_SLIDE_RESULTS:  '/api/search/slide/',
    GET_SEARCH_CASE_RESULTS:  '/api/search/case/',
    IHC_PROFILE: '/api/ihc/profiles/',
})